import React from "react"
import { Checkbox, Grid } from "@material-ui/core"
import OpenInNewIcon from "@material-ui/icons/OpenInNew"
import { Portlet, Text, themeColors } from "letalkui"

import useStyles from "@/pages/Admin/Automation/Webhook/Configure/components/EventCard/styles"

type EventCardProps = {
	title: string
	description: string
	isSelected: boolean
	onToggle: () => void
	onViewPayloadExample: () => void
}

const EventCard: React.FC<EventCardProps> = (props) => {
	const {
		title,
		description,
		isSelected,
		onToggle,
		onViewPayloadExample
	} = props

	const classes = useStyles()

	const handleCheckboxChange = () => {
		onToggle()
	}

	const handlePayloadLinkClick = () => {
		onViewPayloadExample()
	}

	return (
		<Grid item xs={12}>
			<Portlet
				elevation={1}
				className={classes.card}
			>
				<Grid
					container
					alignItems="center"
					justifyContent="space-between"
					spacing={1}
				>
					<Grid item xs>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Text.Body type="default" sx={{ fontWeight: 600, color: themeColors.colors.system.gray[800] }}>
									{title}
								</Text.Body>
							</Grid>
							<Grid item>
								<Text.Body type="small2" sx={{ color: themeColors.colors.system.gray[500] }}>
									{description}
								</Text.Body>
							</Grid>
							<Grid item>
								<Grid
									container
									alignItems="center"
									spacing={1}
									className={classes.payloadLink}
									onClick={handlePayloadLinkClick}
								>
									<Grid item>
										<OpenInNewIcon className={classes.payloadLinkIcon} />
									</Grid>
									<Grid item>
										<Text.Body type="smaller1" sx={{ fontWeight: 800, color: themeColors.colors.system.purple[600] }}>
											Ver exemplo de payload
										</Text.Body>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Checkbox
							checked={isSelected}
							onChange={handleCheckboxChange}
							className={classes.checkbox}
						/>
					</Grid>
				</Grid>
			</Portlet>
		</Grid>
	)
}

export default EventCard
